// extracted by mini-css-extract-plugin
module.exports = {"popover__spacer":"DropDownFilter_popover__spacer__yP0ph"};